// extracted by mini-css-extract-plugin
export default {"container":"Branding_container__1Wbtr","action":"Branding_action__Wci+R","actionText":"Branding_actionText__iqV87"};